import React , { useEffect } from 'react';
import './App.css';
import Images from './img'
import { FormSign, MainPage } from './components'
import { Route, Switch, useHistory } from 'react-router-dom'

function App() {
  const history = useHistory()
  
  useEffect(()=>{
    console.clear()
    if (localStorage.getItem('account')) {
      history.replace('/manage')
    }
  },[history])

  return (
    <div className="App" style={{ flexFlow: 1 }}>
      <Switch>
        <Route path="/manage">
          <MainPage/>
        </Route>
        <Route path="/">
          <div style={{ background: `url('${Images.tenorBg}')`, backgroundSize: "100%" ,height: "100vh", overflow: "hidden" }}>
          <div className="row" data-testid="formSign-test">
            <div className="col"></div>
            <div className="col-3 py-3" style={{ backgroundColor: "white", marginTop: "30vh" }}>
              <img src={ Images.SmadavProtect } alt="logo" style={{ height: "150px", marginBottom: "-32px" }}/>
              <br/>
              <span style={{ fontSize: "30px", fontWeight: "bold" }}> SmadavProtect </span>
              <FormSign />
            </div>
            <div className="col"></div>
          </div>
          </div>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
